import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Button } from '../components/ui/button';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="About Kerry M Holloway - 35+ Years of Insurance Experience in Prineville, Oregon"
        description="Meet Kerry M Holloway, an independent insurance agent in Prineville, Oregon with 35+ years of experience. Affiliated with AIC Insurance since 2009, serving contractors, businesses, and families across Central Oregon."
        path="/about"
      />
      {/* Hero Section */}
      <section className="bg-white" style={{ paddingTop: "360px", paddingBottom: "48px" }}>
        <div className="container mx-auto px-4 sm:px-6 lg:px-12">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F1F1F] mb-4 sm:mb-6">
                About Kerry M Holloway Agency
              </h1>
            </div>

            {/* Kerry's Photo and Story Section */}
            <div className="grid lg:grid-cols-5 gap-12 items-start mb-16">
              {/* Photo */}
              <div className="lg:col-span-2">
                <div className="relative rounded-lg overflow-hidden shadow-xl">
                  <img
                    src="/kerry-photo.jpg"
                    alt="Kerry M Holloway"
                    className="w-full h-auto"
                  />
                </div>
                <div className="mt-6 text-center lg:text-left">
                  <h3 className="text-xl font-bold text-[#1F1F1F]">Kerry M Holloway</h3>
                  <p className="text-gray-600 mt-1">Independent Insurance Agent</p>
                  <p className="text-sm text-gray-500 mt-1">Affiliated with AIC Insurance since 2009</p>
                </div>
              </div>

              {/* Story Content */}
              <div className="lg:col-span-3 space-y-6 text-lg leading-relaxed text-gray-700">
                <p>
                  I've been helping people in Central Oregon protect what matters most—and I've been affiliated with AIC Insurance since 2009.
                </p>
                
                <p>
                  Over the years, I've learned something simple: insurance isn't about policies. It's about people—and the things they've worked hard for.
                </p>
                
                <p>
                  I grew up in Oregon and have built my life and business here in Central Oregon. I understand the lifestyle, the weather, and the risks that come with living and working in this part of the state. Whether you're a contractor, business owner, or just want solid coverage without the confusion, I know what to look for—and what questions to ask.
                </p>

                <p>
                  I've raised my family here. I've built my business here.
                  <br />
                  This community isn't just where I work—it's home.
                </p>

                <p>
                  My approach is straightforward: real conversations, clear answers, and no runaround. I want you to actually understand what you have—and why you have it.
                </p>

                <p>
                  As an independent agent, I can look at different options and help you figure out what makes the most sense. Sometimes that means making changes. Sometimes it means you're already in a good place.
                </p>

                <p>
                  Either way, you'll have someone you can call when things change—or when life throws something unexpected your way.
                </p>

                <p className="font-medium text-[#1F1F1F]">
                  This isn't just what I do—it's how I take care of the people I work with.
                </p>
              </div>
            </div>

            {/* CTA Section */}
            <div className="text-center pt-12 border-t border-gray-200">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1F1F1F] mb-6">
                Ready to Have a Conversation?
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Whether you're looking for new coverage or want to review what you have, I'm here to help.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/quote">
                  <Button size="lg" className="bg-[#D94B5A] hover:bg-red-800 text-white font-medium px-8 py-6 text-base">
                    Get a Quote
                  </Button>
                </Link>
                <Link to="/contact">
                  <Button size="lg" variant="outline" className="border-2 border-[#1F1F1F] text-[#1F1F1F] hover:bg-[#1F1F1F] hover:text-white transition-all duration-300 px-8 py-6 text-base font-medium">
                    Contact Me
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
